import { Commit, Module } from 'vuex';
import { Store } from '../store';

export interface State {
  tracking: boolean;
}

/**
 * This is a generator for the tracking module.
 * By adding a definition below, a default mutation and an action are created.
 * This is useful, because those actions/mutations are only stubs serving the purpose of activating
 * the tracking store subscription.
 */
const DEFINITIONS: string[] = ['testEvent']; // simply add your new tracking actions

const defaultAction =
  (name: string) =>
  ({ commit }: { commit: Commit }) => {
    commit(name);
  };

const defaultMutation = (state: State) => {
  state.tracking = true;
};

export const tracking = DEFINITIONS.reduce<Module<State, Store>>(
  (obj, definition) => {
    if (obj.actions) {
      obj.actions[definition] = defaultAction(definition);
    }
    if (obj.mutations) {
      obj.mutations[definition] = defaultMutation;
    }
    return obj;
  },
  {
    namespaced: true,
    state: {
      tracking: true,
    },
    actions: {},
    mutations: {},
  },
);
